import { getUser } from "../actionsGet/actionGetUser";
import getAPI from "@API/index";

export const editUser = (body, history) => {
  const trimmedBody = {
    ...body,
  };
  return (dispatch) => {
    return getAPI()
      .request({
        method: "put",
        url: `/api/Account`,
        data: trimmedBody,
      })
      .then(() => {
        dispatch(getUser(body.id));
      });
  };
};
